import lessRequire from '../../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import renderViewsState from '../../shared/render-views-state';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TableTicketsList from './components/table-tickets';
import CreateTicketForm from './components/create-ticket-form';
import AttentionBlock from './components/attention-block';

lessRequire('modules/tickets/list/main.less');

const Main = renderViewsState(props => {
	const { intl } = props;

	return (
		<div className="tickets-wrap container">
			<div className="content-container tickets-wrap__create clearfix">
				<div className="tickets-wrap__position-left">
					<div className="content-container__title">
						<h2 className="font-proxima-nova-bold">{intl('Отправить тикет в систему')}</h2>
					</div>
					<CreateTicketForm
						{...props}
						priorities={props.formData.priorityOptions}
						createTicket={props.createTicket}
						initialValues={props.formData.initialValues}
						enableReinitialize={true}
						keepDirtyOnReinitialize={true}
						filesToUpload={props.formData.filesToUpload}
						uploadError={props.formData.uploadError}
						intl={props.intl}
					/>
				</div>
				<div className="tickets-wrap__position-right">
					<div className="tickets-wrap__meta">
						<div className="content-container__title">
							<h2 className="font-proxima-nova-bold">{intl('Внимание!')}</h2>
						</div>
						<AttentionBlock ticketParams={props.ticketParams} intl={intl} />
					</div>
				</div>
			</div>

			<div className="content-container">
				<div className="content-container__title">
					<h2 className="font-proxima-nova-bold">{intl('Список тикетов')}</h2>
				</div>
				<div className="content-container__body">
					<TableTicketsList
						tableRows={props.dataTable.data}
						tableHeaders={props.tableHeaders}
						sortByColumn={props.sortByColumn}
						columnSorting={props.columnSorting}
						showMore={props.pagination().showMore}
						isCanNotMoveToNext={props.dataTable.isCanNotMoveToNext}
						intl={intl}
					/>
				</div>
			</div>
		</div>
	);
});

export default connect(
	state => ({
		data: selectors.getData(state),
		tableHeaders: selectors.getTableHeaders(state),
		dataTable: selectors.getTableData(state),
		columnSorting: selectors.getColumnSorting(state),
		formData: selectors.getFormData(state),
		ticketParams: selectors.getTicketParams(state),
		progressBar: selectors.getProgressBar(state),
		intl: selectors.getIntl(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/tickets/list/main.js